import { storeStructure } from '../store/reducers';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: storeStructure.VoD,
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,  
  isSelectable: true,
  emptyMessage: "You don't have VoD, visit the vod section to create one.",
  getURL: 'getAllVodSuccess',
  fields: [
     {
      attributeName: 'folder',
      label: 'Folder',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Folder of VoD Job in process or processed.',
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Name of VoD Job in process or processed.',
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'outputFile',
      label: '1st Output',
      helpText: 'URL of the first output file, you can see more output URLs on the VoD detail page.',
      width: '20rem',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'type',
      label: 'Type',
      helpText: 'Type of VoD.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canOrder: true,
      canFilter: true,
      exactWidth: '150px',
      filterSelectOptions: [
        { name: 'Type filter...', value: 'no-filter' },
        { name: 'equirectangular', value: 'globe' },
        { name: '180º', value: '180' },
        { name: 'flat', value: 'flat' },
        { name: 'control room', value: 'croom' },
      ]
    },
    {
      attributeName: 'status',
      label: 'Status',
      helpText: 'Status of VoD job.',
      type: FormInputTypes.STATUS,
      secondaryValue: 'log',
      // width: '10rem',
      exactWidth: '100px',
      colors: {
        preparing: 'bg-warning',
        enqueued: 'bg-info',
        processing: 'bg-info',
        success: 'bg-success',
        error: 'bg-danger',
        fatal: 'bg-danger',
      },
    },
    {
      attributeName: 'hls_enable',
      label: 'HLS enabled',
      helpText: 'HLS enabled',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canOrder: true,
      canFilter: false,
      
    }
  ],
};
